import * as React from "react"
import * as UI from "@iyk/music-ui"

export const TruncateText = ({
  className,
  children,
  lineClamp
}: {
  className?: string
  children: React.ReactNode
  lineClamp: number
}) => {
  const ref = React.useRef<HTMLSpanElement>(null)
  const [isExpanded, setIsExpanded] = React.useState(false)
  const [needsTruncate, setNeedsTruncate] = React.useState(false)

  const measureHeights = () => {
    if (!ref.current) return

    const closed = ref.current.getBoundingClientRect().height
    const opened = ref.current.scrollHeight

    setNeedsTruncate(opened > closed)
  }

  React.useEffect(() => {
    const observer = new ResizeObserver(measureHeights)
    if (ref.current && !isExpanded) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
  }, [isExpanded])

  return (
    <div
      style={{ "--line-clamp": isExpanded ? "unset" : lineClamp } as React.CSSProperties}
      className={UI.cx("flex flex-col items-start gap-1", className)}
    >
      <span ref={ref} className="line-clamp-[var(--line-clamp)] whitespace-pre-wrap">
        {children}
      </span>

      {needsTruncate && (
        <button
          type="button"
          className={UI.cx(
            "[font-size:inherit] text-gray-12 bshadow-b bshadow-transparent hover:bshadow-gray-12 transition"
          )}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  )
}
